import React, { useState, useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';
import { IMLocationLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import { WM } from '../../../../../const/constants';
import { LocationTypes } from '../../../../../enum/Enum';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const accessToken = props.oidc?.user?.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const [locationLayout, setLocationLayout] = useState(() =>
        IMLocationLookupLayout({ RWarehouse: props.formFields?.R_PLANWAREHOUSE || '', moduleType: WM, locationType: LocationTypes.DockDoor })
    );
    const [formKey, setFormKey] = useState(0);

    const finalLayout = useMemo(() => {
        return PrimaryLayout(locationLayout);
    }, [locationLayout]);

    const loadLookupFromDataSource = useCallback((name, dataSource) => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (typeof ref.instance === 'function') {
            const instance = ref.instance();
            if (instance && typeof instance.option === 'function') {
                instance.option('dataSource', dataSource);
                instance.option('valueExpr', 'id');
                instance.option('displayExpr', 'name');
            }
        }
    }, [props.formRefs]);

    // Handles actual value changes (GUID values) from the lookup/select fields
    const handleFieldValueChange = useCallback((name, value, e) => {
        if (name === "R_PLANWAREHOUSE" && value) {
            const newLayout = IMLocationLookupLayout({ RWarehouse: value, moduleType: WM, locationType: LocationTypes.DockDoor });
            setLocationLayout(newLayout);
        }
        if (name === "R_STAGINGWAREHOUSE") {
            // Clear staging area when warehouse changes
            if (props.formRefs?.current?.['R_STAGINGAREA']) {
                props.formRefs.current['R_STAGINGAREA'].instance().option('value', null);
            }
            if (value) {
                var areaDataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                        loadParams: {
                            locationTypes: 'L',
                            warehouseRowId: value
                        },
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("R_STAGINGAREA", areaDataSource);
            }
        }
        props.handleFieldChange(name, value);
    }, [props.handleFieldChange, accessToken, loadLookupFromDataSource, props.formRefs]);
    var areaDataSource = new DataSource({
        store: new createStore({
            key: 'id',
            loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
            loadParams: {
                locationTypes: 'L',
            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
        paginate: true,
        pageSize: 100
    });
    loadLookupFromDataSource("R_STAGINGAREA", areaDataSource);
    // Handles lookup grid row selection (receives full row object, not just the ID)
    // Only used for side effects - do NOT set form field here as handleFieldValueChange already handles that
    const handleLookupSelection = useCallback((name, selectedItem) => {
        if (name === "R_PLANWAREHOUSE" && selectedItem) {
            const warehouseId = selectedItem?.id || selectedItem;
            if (warehouseId && typeof warehouseId === 'string') {
                const newLayout = IMLocationLookupLayout({ RWarehouse: warehouseId, moduleType: WM, locationType: LocationTypes.DockDoor });
                setLocationLayout(newLayout);
            }
        }
    }, []);

    useEffect(() => {
        setFormKey(prev => prev + 1);
    }, [locationLayout]);

    useEffect(() => {
        const wh = props.formFields?.R_PLANWAREHOUSE;
        if (wh && wh !== '00000000-0000-0000-0000-000000000000') {
            setLocationLayout(
                IMLocationLookupLayout({
                    RWarehouse: wh,
                    moduleType: WM,
                    locationType: LocationTypes.DockDoor,
                })
            );
        }
    }, [props.formFields?.R_PLANWAREHOUSE]);

    const handlePrimaryFormLoad = useCallback(() => {
        // Load staging area data source if staging warehouse is already set
        if (props.formFields?.R_STAGINGWAREHOUSE) {
            var stagingAreaDataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                    loadParams: {
                        locationTypes: 'L',
                        warehouseRowId: props.formFields.R_STAGINGWAREHOUSE
                    },
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("R_STAGINGAREA", stagingAreaDataSource);
        }

        var profileDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfiles`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_PROFILE", profileDataSource);

        var customerDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomers`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_CUSTOMER", customerDataSource);
    }, [accessToken, loadLookupFromDataSource]);

    return (
        <div>
            <FormField
                key={formKey}
                currrentUser={currentUser}
                layoutId='7A8B9C0D-E1F2-3456-789A-BCDEF0123456'
                layoutName='WMSchedulesManagementPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldValueChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={handleLookupSelection}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
